import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppRouterService } from '../shared/router-service.service';
import { LoginService } from './login.service';
import { AuctionService } from '../auction/auction.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  const auctionService = inject(AuctionService);
  const appRouter = inject(AppRouterService);
  const loginService = inject(LoginService);

  return checkAccess(state.url, auctionService, appRouter, loginService);
};

export const authGuardChild = authGuard;

async function checkAccess(
  url: string,
  auctionService: AuctionService,
  appRouter: AppRouterService,
  loginService: LoginService
) {
  await auctionService.load();

  if (!loginService.user) {
    return appRouter.getLoginUrl();
  }

  const noEventTree = appRouter.getWithoutEventUrl();
  const noEventUrl = noEventTree.toString();
  const isNoEventUrl = url === noEventUrl;

  if (!isNoEventUrl) {
    if (!auctionService.isAnyAuctionRunning()) {
      return noEventTree;
    }

    const auctionUrl = appRouter.getAuctionRoomUrl().toString();
    const shouldVerifyAuction = ![auctionUrl, noEventUrl].includes(url);
    const isAuctionIdPresent = !!loginService.getAuction()?.auctionId;

    if (shouldVerifyAuction && !isAuctionIdPresent) {
      return appRouter.getAuctionRoomUrl();
    }
  }
  return true;
}
